<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/modules/auth/stores/auth.store'

const authStore = useAuthStore()
const router = useRouter()
const menu = ref()

const user = computed(() => authStore.userData)

function displayContextMenu(event) {
  menu.value.toggle(event)
}

async function handleLogout() {
  try {
    await authStore.logout()
    router.push({ name: 'AuthLogin' })
  }
  catch (error) {
    console.error('Logout failed:', error)
  }
}
</script>

<template>
  <dss-menu-avatar
    class="cursor-pointer"
    :aria-label="$t('core.menu.user.profile-button')"
    @click="displayContextMenu($event)"
  />

  <Popover
    ref="menu"
    class="w-64 bg-dss-secondary-500! before:hidden after:hidden mt-7! drop-shadow-lg! rounded-2xl! rounded-tr-none!"
  >
    <div class="flex flex-col justify-between gap-4 w-full">
      <div class="flex-1 flex flex-col gap-2">
        <div class="flex flex-col text-white text-base/8">
          <span> {{ user?.firstName }} {{ user?.lastName }} </span>
          <span class="text-surface-400 text-xs">
            {{ user?.email }}
          </span>
          <div class="flex flex-wrap gap-2 mt-2">
            <Tag
              v-for="role in user?.permissionGroups"
              :key="role._id"
              :value="role.name"
              pt:root="bg-dss-secondary-400/60 border border-[#484A81B0] rounded-lg text-xs px-2 py-1"
            />
          </div>
        </div>
      </div>

      <hr class="border-t border-[#484A81B0]">

      <div>
        <a
          href="#"
          class="text-dss-surface-menu text-sm"
          @click.prevent="handleLogout"
        >
          {{ $t("core.menu.user.logout") }}
        </a>
      </div>
    </div>
  </Popover>
</template>

<style scoped></style>
